




















import { Component, Prop, Vue } from 'vue-property-decorator';

import Typography from '@/componentsV2/atoms/Typography/Typography.vue';
import Checkbox from '@/components/Checkbox/Checkbox.vue';

@Component({
  components: {
    Typography,
    Checkbox
  }
})
export default class SectionHeader extends Vue {
  @Prop() title!: string;
  @Prop() description!: string;
  @Prop({ default: true }) showToggle!: boolean;
  @Prop({ default: true }) enabled!: boolean;
}
